module.exports = __webpack_public_path__ + "static/img/2.5197b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/restaurante/2.jpg
// module id = z3xf
// module chunks = 1